module.exports = __webpack_public_path__ + "img/object-group.285bee85.svg";